import { $host } from './index';
import { ENDPOINTS } from '../constants/endpoints';

export const getProducts = (categoryId, page = 1, limit = 8) => async dispatch => {
  try {
    dispatch({type: 'App/SET_ACTIVITY', payload: true})
    const { data } = await $host.get(ENDPOINTS.PRODUCTS.LIST, {
      params: { categoryId, page, limit }
    });
    dispatch({ type: 'Products/SET_PRODUCTS', payload: data.data });
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  } finally {
    dispatch({type: 'App/SET_ACTIVITY', payload: false})
  }
};

export const getProduct = async (id) => {
  try {
    const { data } = await $host.get(ENDPOINTS.PRODUCTS.INFO(id));
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const getProductsDenominations = (id) => async (dispatch) => {
  try {
    dispatch({type: 'App/SET_ACTIVITY', payload: true})
    const { data } = await $host.get(ENDPOINTS.PRODUCTS.DENOMINATIONS(id));
    return data.sort((a,b) => a.price - b.price);
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  } finally {
    dispatch({type: 'App/SET_ACTIVITY', payload: false})
  }
};

export const getCategories = () => async dispatch => {
  try {
    dispatch({type: 'App/SET_ACTIVITY', payload: true})
    const { data } = await $host.get(ENDPOINTS.PRODUCTS.CATEGORIES);
    dispatch({ type: 'Products/SET_CATEGORIES', payload: data });
    dispatch({ type: 'Products/SET_ACTIVE_CATEGORY', payload: data[0] });
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  } finally {
    dispatch({type: 'App/SET_ACTIVITY', payload: false})
  }
};
